import { render, staticRenderFns } from "./WorkspaceList.vue?vue&type=template&id=08e4cd07&scoped=true&"
import script from "./WorkspaceList.vue?vue&type=script&lang=ts&"
export * from "./WorkspaceList.vue?vue&type=script&lang=ts&"
import style0 from "./WorkspaceList.vue?vue&type=style&index=0&id=08e4cd07&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e4cd07",
  null
  
)

export default component.exports